@if (loading.visible()) {
  <div
    class="dp-loader"
    role="status"
    aria-live="polite"
    aria-label="DeskPlus One est&aacute; cargando"
  >
    <div class="dp-loader__ambient"></div>
    <div class="dp-loader__grid"></div>

    <header class="dp-loader__header">
      <img
        src="/assets/brand/deskplus-one-horizontal.svg"
        alt="DeskPlus One"
        class="dp-loader__brand"
      />

      <div class="dp-loader__promise">
        <span>Service Experience, Reimagined</span>
        <i></i>
      </div>
    </header>

    <main class="dp-loader__content">
      <div class="dp-loader__network">
        <div class="status-card status-card--one">
          <span class="status-icon">&#9673;</span>
          <span>Conectando<br />servicios</span>
        </div>

        <div class="status-card status-card--two">
          <span class="status-icon">&#9645;</span>
          <span>Consultando<br />informaci&oacute;n</span>
        </div>

        <div class="status-card status-card--three">
          <span class="status-icon">&#9636;</span>
          <span>Cargando<br />configuraci&oacute;n</span>
        </div>

        <div class="status-card status-card--four">
          <span class="status-icon">&#9679;&#9679;&#9679;</span>
          <span>Preparando<br />tu espacio</span>
        </div>

        <div class="core">
          <div class="core__orbit core__orbit--outer"></div>
          <div class="core__orbit core__orbit--middle"></div>
          <div class="core__orbit core__orbit--active"></div>

          <div class="core__glass">
            <img
              src="/assets/brand/deskplus-one-isotype.svg"
              alt=""
            />
          </div>
        </div>
      </div>

      <section class="dp-loader__message">
        <h1>
          Cargando <strong>DeskPlus One...</strong>
        </h1>

        <p>
          Conectando personas, servicios y automatizaci&oacute;n<br />
          para que tu trabajo sea m&aacute;s simple.
        </p>

        <div class="progress" aria-hidden="true">
          <div class="progress__track">
            <div class="progress__beam"></div>
          </div>
        </div>

        <div class="current-status">
          {{ message() }}
        </div>

        <div class="steps" aria-hidden="true">
          <i class="active"></i>
          <i></i>
          <i></i>
          <i></i>
        </div>
      </section>
    </main>

    <div class="dp-loader__wave dp-loader__wave--one"></div>
    <div class="dp-loader__wave dp-loader__wave--two"></div>

    <footer class="dp-loader__footer">
      <div class="benefits">
        <div>
          <strong>&#9671; Seguro</strong>
          <span>Tu informaci&oacute;n protegida</span>
        </div>

        <div>
          <strong>ÏŸ Confiable</strong>
          <span>Siempre disponible</span>
        </div>

        <div>
          <strong>&infin; Escalable</strong>
          <span>Creciendo contigo</span>
        </div>
      </div>

      <div class="niotech">
        <strong>NIOTECH</strong>
        <span>SISTEMA DE SOPORTE T&Eacute;CNICO</span>
        <small>LA TECNOLOG&Iacute;A QUE IMPULSA TU ORGANIZACI&Oacute;N</small>
      </div>
    </footer>
  </div>
}
